import axios from './axios';
import config from '../../helpers/config';

export default () => {
  const url = config.designBuilderGetDcSignature.replace('<repId>', config.repId()).replace('<siteId>', config.siteId);

  return axios.get(url);
};
